import { makeStyles, Theme } from '@forgeglobal/design-framework';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: 512,
    padding: theme.spacing(0, 3, 6),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
  },
  accountNumber: {
    marginBottom: theme.spacing(8),
    color: theme.palette.grey[550],
  },
  assetInfo: {
    display: 'grid',
    gridTemplateColumns: 'fit-content(40%) 1fr',
    gridColumnGap: theme.spacing(6),
    gridRowGap: theme.spacing(2),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  assetData: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  asOf: {
    paddingTop: theme.spacing(1),
  },
  checkbox: {
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(1),
    '& .MuiFormControlLabel-label': {
      paddingTop: '2px',
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      fontSize: 14,
    },
  },
  dialogWrapper: {
    padding: theme.spacing(4, 5),
  },
  dialogText: {
    marginBottom: theme.spacing(6),
    whiteSpace: 'pre-line',
  },
  dialogButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  mainForm: {
    marginBottom: theme.spacing(5),
  },
  spinnerContainer: {
    display: 'flex',
  },
  spinnerWrapper: {
    width: 600,
  },
  infoGroup: {
    marginBottom: theme.spacing(2),
  },
  summaryIcon: {
    fontSize: '0.9rem',
    '&:hover': {
      color: theme.palette.grey[450],
    },
  },
  infoList: {
    margin: theme.spacing(0),
    paddingInlineStart: theme.spacing(3),
  },
  importantText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  summary: {
    fontWeight: 'inherit',
  },
  expandedSummary: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

export default useStyles;
